module.exports = __webpack_public_path__ + "img/p4-active.6a2b4794.png";